import { createReducer } from '@reduxjs/toolkit';

import { Loadable, FaftPrioritisationManager } from 'models';
import { makeThunkFromAPICall } from 'state';

export type FaftPrioritisationState = {
    faftPrioritisationTask: Loadable<FaftPrioritisationManager.FaftPrioritisationTask>;
    faftPrioritisationSummaryStatistics: Loadable<
        FaftPrioritisationManager.FaftPrioritisationSummaryStatistics[]
    >;
    faftPrioritisationStatistics: Loadable<FaftPrioritisationManager.FaftPrioritisationStatistics>;
};

const initialState: FaftPrioritisationState = {
    faftPrioritisationTask: {
        status: 'idle',
    },
    faftPrioritisationSummaryStatistics: {
        status: 'idle',
    },
    faftPrioritisationStatistics: {
        status: 'idle',
    },
};

export const [
    getFaftPrioritisationStatistics,
    setFaftPrioritisationStatistics,
] = makeThunkFromAPICall(
    FaftPrioritisationManager.getFaftPrioritisationStatistics,
    'faft/prioritisation/planid/statistics/faftid',
);

export const [
    updateFaftPrioritisationStatistics,
    setUpdatedFaftPrioritisationStatistics,
] = makeThunkFromAPICall(
    FaftPrioritisationManager.updateFaftPrioritisationStatistics, // Assumes the existence of this API method
    'faft/prioritisation/planid/statistics/faftid2',
);

export const [
    getFaftPrioritisationSummaryStatistics,
    setFaftPrioritisationSummaryStatistics,
] = makeThunkFromAPICall(
    FaftPrioritisationManager.getFaftPrioritisationSummaryStatistics,
    'faft/prioritisation/planid/summarystatistics',
);

export const [getFaftPrioritisationTask, setFaftPrioritisationTask] =
    makeThunkFromAPICall(
        FaftPrioritisationManager.getFaftPrioritisationTask,
        'faft/prioritisation/task',
    );

export const faftPrioritisationReducer = createReducer(
    initialState,
    (builder) => {
        builder.addCase(setFaftPrioritisationTask, (state, action) => {
            return {
                ...state,
                faftPrioritisationTask: {
                    ...state.faftPrioritisationTask,
                    ...action.payload.loadable,
                },
            };
        });
        builder.addCase(
            setFaftPrioritisationSummaryStatistics,
            (state, action) => {
                return {
                    ...state,
                    faftPrioritisationSummaryStatistics: {
                        ...state.faftPrioritisationSummaryStatistics,
                        ...action.payload.loadable,
                    },
                };
            },
        );

        builder.addCase(setFaftPrioritisationStatistics, (state, action) => {
            return {
                ...state,
                faftPrioritisationStatistics: {
                    ...state.faftPrioritisationStatistics,
                    ...action.payload.loadable,
                },
            };
        });

        builder.addCase(
            setUpdatedFaftPrioritisationStatistics,
            (state, action) => {
                return {
                    ...state,
                    faftPrioritisationStatistics: {
                        ...state.faftPrioritisationStatistics,
                        ...action.payload.loadable,
                    },
                };
            },
        );
    },
);

export const FaftPrioritisationActions = {
    getFaftPrioritisationStatistics,
    getFaftPrioritisationSummaryStatistics,
    updateFaftPrioritisationStatistics,
    getFaftPrioritisationTask,
};

export default faftPrioritisationReducer;
